/* eslint-disable arrow-body-style */
// @flow
import React from 'react';
import classNames from 'classnames';
import Icon from 'components/_particles/icon/react/Icon';
import { t } from 'javascripts/utils/withTranslation';

type Props = {
  keyNumber: number,
  text?: string,
  appearance?: 'default' | 'icon',
};

// Viba-Status // "0: Keine Teilnahme 1: Teilnahme ohne Antragstellung 2: Teilnahme mit Antragstellung"
export const vibaIcons: { [key: number]: string } = {
  0: 'bw-cross-large-line',
  1: 'bw-circle-line',
  2: 'bw-checkmark-line',
};

const VibaStatus = ({
  keyNumber,
  text,
  appearance = 'default',
}: Props): React$MixedElement => {
  return (
    <div
      className={classNames('viba-status', `viba-status--${appearance}`)}
      aria-hidden={appearance === 'icon' && !text}
    >
      <span className="viba-staus__icon">
        <Icon icon={vibaIcons[keyNumber || 0]} />
      </span>
      {text && (
        <>
          <span className="u-hidden-visually">{t('ViBa-Status')}</span>
          <span className="viba-status__text">{text}</span>
        </>
      )}
    </div>
  );
};

export default VibaStatus;
